export const appContextTypes = {
  SET_APP_LANGUAGE: "context/SET_APP_LANGUAGE",
  SET_APP_USER: "context/SET_APP_USER",
  DISPOSE_USER: "context/DISPOSE_USER",
};
